export default "__VITE_ASSET__DXRrG7yO__"